import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJsfiddleComponent } from './simple-icons-jsfiddle.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJsfiddleComponent ],
    exports:      [ SimpleIconsJsfiddleComponent ],
    bootstrap:    []
})
export class SimpleIconsJsfiddleModule {}
